import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function AzureIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_10640_68214)">
        <path
          d="M8.05212 0.838235H15.063L7.78519 22.4015C7.71046 22.6231 7.56805 22.8158 7.37805 22.9522C7.18805 23.0886 6.96002 23.162 6.72611 23.1619H1.27012C1.09292 23.1619 0.918279 23.1197 0.760613 23.0388C0.602948 22.958 0.466784 22.8407 0.36337 22.6969C0.259985 22.5529 0.192369 22.3865 0.166118 22.2112C0.139868 22.036 0.155739 21.857 0.212418 21.6891L6.99304 1.59851C7.06781 1.37687 7.21022 1.18427 7.40021 1.04782C7.5902 0.91137 7.8182 0.837947 8.05212 0.837891V0.838235Z"
          fill="url(#paint0_linear_10640_68214)"
        />
        <path
          d="M18.2402 15.3013H7.12273C7.01935 15.3011 6.91831 15.332 6.83279 15.3901C6.74726 15.4482 6.68123 15.5307 6.6433 15.6269C6.60536 15.723 6.59729 15.8284 6.62014 15.9292C6.64298 16.0301 6.69568 16.1217 6.77136 16.1921L13.9151 22.86C14.1231 23.054 14.397 23.1619 14.6814 23.1618H20.9765L18.2402 15.3013Z"
          fill="#0078D4"
        />
        <path
          d="M8.05247 0.837898C7.81601 0.83701 7.58545 0.911747 7.39448 1.05119C7.20351 1.19064 7.06213 1.38749 6.99098 1.61299L0.221214 21.6705C0.160778 21.839 0.14181 22.0196 0.165914 22.197C0.190019 22.3744 0.256486 22.5433 0.359696 22.6896C0.462905 22.8358 0.59982 22.9551 0.758861 23.0373C0.917902 23.1194 1.09439 23.1621 1.2734 23.1616H6.87035C7.0788 23.1244 7.27362 23.0325 7.43493 22.8953C7.59623 22.7581 7.71823 22.5806 7.78847 22.3808L9.13843 18.4021L13.9608 22.8999C14.1628 23.067 14.4163 23.1595 14.6785 23.1616H20.9503L18.1995 15.3011L10.181 15.303L15.0886 0.837898H8.05247Z"
          fill="url(#paint1_linear_10640_68214)"
        />
        <path
          d="M17.0068 1.59713C16.9321 1.3758 16.7899 1.18348 16.6001 1.04727C16.4104 0.911062 16.1827 0.837828 15.9491 0.837891H8.13574C8.36928 0.837916 8.59693 0.911187 8.78664 1.04739C8.97636 1.18359 9.11857 1.37586 9.19327 1.59713L15.9741 21.6886C16.0308 21.8565 16.0468 22.0356 16.0206 22.2109C15.9944 22.3862 15.9268 22.5527 15.8235 22.6967C15.7201 22.8407 15.5839 22.958 15.4262 23.0389C15.2685 23.1198 15.0938 23.162 14.9165 23.1619H22.7302C22.9074 23.1618 23.082 23.1195 23.2396 23.0386C23.3972 22.9576 23.5333 22.8403 23.6366 22.6964C23.7399 22.5524 23.8075 22.3859 23.8338 22.2107C23.86 22.0355 23.8442 21.8565 23.7876 21.6886L17.0068 1.59713Z"
          fill="url(#paint2_linear_10640_68214)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10640_68214"
          x1="10.6075"
          y1="2.49251"
          x2="3.32659"
          y2="24.0017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10640_68214"
          x1="12.8821"
          y1="12.516"
          x2="11.198"
          y2="13.0854"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.3" />
          <stop offset="0.071" stopOpacity="0.2" />
          <stop offset="0.321" stopOpacity="0.1" />
          <stop offset="0.623" stopOpacity="0.05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10640_68214"
          x1="11.9556"
          y1="1.86475"
          x2="19.9478"
          y2="23.1573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
        <clipPath id="clip0_10640_68214">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
